import { Feature } from 'common/models/page-config.models';
import { WidgetActionOption, WidgetType } from '../../models/widget.model';
import { REPORTS_ROUTES } from 'routes/routes.const';

export interface WidgetMenuItem {
  id: WidgetActionOption;
  text: string;
  feature?: Feature[] | Feature;
}

export const WIDGET_ACTIONS: WidgetMenuItem[] = [
  {
    id: WidgetActionOption.AddToReport,
    text: 'Add to Dashboard',
    feature: Feature.AddToDashboard,
  },
  {
    id: WidgetActionOption.IncludeAll,
    text: 'Show Empty Responses',
  },
  {
    id: WidgetActionOption.ExcludeAll,
    text: 'Hide Empty Responses',
  },
  {
    id: WidgetActionOption.ExportPowerpoint,
    text: 'Export to PowerPoint',
  },
  {
    id: WidgetActionOption.ExportExcelChart,
    text: 'Export to Excel',
  },
  {
    id: WidgetActionOption.ExportExcelAllColumns,
    text: 'Export to Excel',
  },
  {
    id: WidgetActionOption.ExportExcelVisibleColumns,
    text: 'Export to Excel (Visible Columns)',
  },
  {
    id: WidgetActionOption.ResetWidgetOptions,
    text: 'Reset Widget Options',
  },
];

export const convertLineChartIds = [WidgetType.LATEST_ALIGNMENT];

export const BAR_CHART_WIDGET_TYPES = [WidgetType.BAR_CHART, WidgetType.ALIGNMENT_DISTRIBUTION];

export const NON_FILTER_GROUPS = ['total'];

export const URLS_WITH_NO_PROFILE_NAME_REDIRECT = [REPORTS_ROUTES.configurator];
